import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScheduleForm from "./pages/ScheduleForm";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import ContactUs from "./pages/ContactUs";
import MedOps from "./pages/MedOps";
import PharmaConnect from "./pages/PharmaConnect";
import Blog from "./pages/Blog";
import InPatientOutPatientBlog from "./pages/InPatientOutPatientBlog";
import VoicePrescriptionBlog from "./pages/VoicePrescriptionBlog";
import InventoryTrackingBlog from "./pages/InventoryTrackingBlog";
import HospitalPharmacyIntegrationBlog from "./pages/HospitalPharmacyIntegrationBlog";
import DiagnosticLabIntegrationBlog from "./pages/DiagnosticLabIntegrationBlog";
import AdvancedAnalyticsCampaignBlog from "./pages/AdvancedAnalyticsCampaignBlog";
import PredictiveAnalyticsBlog from "./pages/PredictiveAnalyticsBlog";
import BestHMSforYourHospitalBlog from "./pages/BestHMSforYourHospitalBlog";
import CuttingDownPatientDeliveryTimewithAIBlog from "./pages/CuttingDownPatientReportDeliveryTimewithAIBlog";
import MedicineForecastingBlog from "./pages/MedicineForecastingBlog";
import ApiIntegrationsSection from "./pages/ApiIntegrationsection";
import Brouchers from "./pages/Brouchers";

import "./index.css";
import ProChatWidget from "./components/ProChatWidget";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/medops" element={<MedOps />} />
        <Route
          path="/apiintegrationssection"
          element={<ApiIntegrationsSection />}
        />
        <Route path="/pharmaconnect" element={<PharmaConnect />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/brouchers" element={<Brouchers />} />
        <Route path="/scheduleform" element={<ScheduleForm />} />
        <Route
          path="/inpatientoutpatientblog"
          element={<InPatientOutPatientBlog />}
        />
        <Route
          path="/voiceprescriptionblog"
          element={<VoicePrescriptionBlog />}
        />
        <Route
          path="/inventorytrackingblog"
          element={<InventoryTrackingBlog />}
        />
        <Route
          path="/hospitalpharmacyintegrationblog"
          element={<HospitalPharmacyIntegrationBlog />}
        />
        <Route
          path="/diagnosticlabintegrationblog"
          element={<DiagnosticLabIntegrationBlog />}
        />
        <Route
          path="/advancedanalyticscampaignblog"
          element={<AdvancedAnalyticsCampaignBlog />}
        />
         <Route
          path="/predictiveanalyticsblog"
          element={<PredictiveAnalyticsBlog />}
        />
         <Route
          path="/besthmsforyourhospitalblog"
          element={<BestHMSforYourHospitalBlog />}
        />
          <Route
          path="/medicineforecastingblog"
          element={<MedicineForecastingBlog />}
        />
         <Route
          path="/cuttingdownpatientreportdeliverytimewithaiblog"
          element={<CuttingDownPatientDeliveryTimewithAIBlog />}
        />
      </Routes>
      <Footer />
      <ProChatWidget />
    </Router>
  );
}

export default App;
